import { h } from "preact";
import { useState } from "preact/hooks";

import OverlayDialog from "../OverlayDialog";
import InputWithLabel from "../InputWithLabel";
import { Keyboard } from "../../foundation/enums";

import styles from "./DeleteDialog.module.css";

interface Props {
    title: string;
    placeholder: string;
    confirmationText: string;
    loading?: boolean;
    onDelete: () => void;
    onClose: () => void;
}

function DeleteDialog({
    title,
    placeholder,
    confirmationText,
    loading,
    onDelete,
    onClose
}: Props) {
    const [value, setValue] = useState("");

    function handleKeyPress(event: KeyboardEvent) {
        if (event.key === Keyboard.Key.Enter && value === confirmationText) {
            onDelete();
        }
    }

    const positiveButtonDisabled = confirmationText !== value;

    return (
        <OverlayDialog
            positiveButtonText="DELETE"
            negativeButtonText="CANCEL"
            positiveButtonDisabled={positiveButtonDisabled}
            onPositiveButtonClick={onDelete}
            hideNegativeButton={false}
            onClose={onClose}
            width={400}
            loading={loading}>
            <div class={styles.deleteDialogBody}>
                <h2>{title}</h2>
                <InputWithLabel
                    autoFocus
                    label={placeholder}
                    onInput={setValue}
                    onKeyPress={handleKeyPress}
                    primary/>
            </div>
        </OverlayDialog>
    );
}

export default DeleteDialog;
